import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Nav, Tab } from "react-bootstrap";
import MetricStorylineChart from "./MetricStorylineChart";
import ActualVsExpectedChart from "./ActualVsExpectedChart";

const ChartViewTabs = ({
  t,
  dataPoints,
  ruleCode,
  selectedPeriod,
  onPeriodSelect,
  onRangeSelect,
  rangeAnchorPeriod,
}) => {
  const [activeTab, setActiveTab] = useState("storyline");

  return (
    <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k || "storyline")}>
      <Nav variant="pills" className="mat-chart-tabs mb-3">
        <Nav.Item>
          <Nav.Link eventKey="storyline">{t("MetricAnomalyTimeline.storylineTab.label")}</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="compare">{t("MetricAnomalyTimeline.compareTab.label")}</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="storyline">
          <MetricStorylineChart
            dataPoints={dataPoints}
            ruleCode={ruleCode}
            selectedPeriod={selectedPeriod}
            onPeriodSelect={onPeriodSelect}
            onRangeSelect={onRangeSelect}
            rangeAnchorPeriod={rangeAnchorPeriod}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="compare">
          <ActualVsExpectedChart dataPoints={dataPoints} ruleCode={ruleCode} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  );
};

export default withTranslation()(ChartViewTabs);
